@if (isVisible) {
  <div class="draw-wrapper">
    <!-- buttons when we are in select mode -->
    <div class="tabs-menu">
      <div class="tab-item add-shadow larger" matRipple [matTooltip]="selectTooltip"
        [class.selected]="state === 'select'" (click)="setSelectMode()">
        <div class="icon"><i class="fas fa-mouse-pointer"></i></div>
      </div>
      <div class="tab-item add-shadow" matRipple [matRippleDisabled]="removeIsDisabled"
        [matTooltipDisabled]="removeIsDisabled" [matTooltip]="removeTooltip" [class.disabled]="removeIsDisabled"
        (click)="removeSelected()">
        <div class="icon"><i class="fas fa-trash"></i></div>
      </div>
    </div>
    <!-- buttons when we are in draw mode -->
    <div class="tabs-menu">
      <div class="tab-item add-shadow larger" matRipple [matTooltip]="drawTooltip" [class.selected]="state === 'draw'"
        (click)="setDrawMode()">
        <div class="icon"><i class="fas fa-pen-nib"></i></div>
      </div>
      <div class="tab-item add-shadow" [matRippleDisabled]="undoIsDisabled" matRipple
        [matTooltipDisabled]="undoIsDisabled" [class.disabled]="undoIsDisabled" [matTooltip]="undoTooltip"
        (click)="undo()">
        <div class="icon"><i class="fas fa-undo"></i></div>
      </div>
      <mat-form-field class="tab-item add-shadow larger" [class.disabled]="state !== 'draw'">
        <mat-select [ngModel]="defaultRoutingProfile" [disabled]="state !== 'draw'"
          (selectionChange)="changeRoutingProfile($event)">
          @for (profile of routingProfiles; track profile) {
            <mat-option [value]="profile.key">
              {{profile.title}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
}


@if (isDrawVisible) {
  <div class="draw-wrapper">
    <!-- buttons when we are in draw mode -->
    <div class="tabs-menu">
      <div class="tab-item add-shadow no-cursor larger selected">
        <div class="icon"><i class="fas fa-pen-nib"></i></div>
      </div>
      <div class="tab-item add-shadow" matRipple [matRippleDisabled]="drawFeatureIsDisabled" matRipple [matTooltipDisabled]="drawFeatureIsDisabled" [class.disabled]="drawFeatureIsDisabled"
        [matTooltip]="createLineTooltip" (click)="createFeature('line')">
        <div class="icon"><i class="fas fa-route"></i></div>
      </div>
      <div class="tab-item add-shadow"  matRipple [matRippleDisabled]="drawFeatureIsDisabled" matRipple [matTooltipDisabled]="drawFeatureIsDisabled" [class.disabled]="drawFeatureIsDisabled"
        [matTooltip]="createPointTooltip" (click)="createFeature('point')">
        <div class="icon"><i class="fas fa-map-marker-alt"></i></div>
      </div>
      <div class="tab-item add-shadow"  matRipple [matRippleDisabled]="drawFeatureIsDisabled" matRipple [matTooltipDisabled]="drawFeatureIsDisabled" [class.disabled]="drawFeatureIsDisabled"
        [matTooltip]="createAreaTooltip" (click)="createFeature('area')">
        <div class="icon"><i class="fas fa-draw-polygon"></i></div>
      </div>
      <div class="tab-item add-shadow" matRipple [matRippleDisabled]="removeFeatureIsDisabled"
        [matTooltipDisabled]="removeFeatureIsDisabled" [matTooltip]="removeFeaturesTooltip"
        [class.disabled]="removeFeatureIsDisabled" (click)="removeFeature()">
        <div class="icon"><i class="fas fa-trash"></i></div>
      </div>
    </div>
  </div>
}